import React from 'react';
import styles from './Footer.module.css';

const Footer: React.FC = () => (
  <div className={styles.footbar}>
    <span>© MMXXVI Oak Cliff Tech</span>
    <span className={styles.glyphs}>▦ ◆ ▸ ✦</span>
    <span>Made in Oak Cliff · Dallas, TX</span>
  </div>
);

export default Footer;
